import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';
import { NotificationPosition } from '../notification.types';

/** @slot - wb-notfication elements */
@Component({
  tag: 'wb-notification-host',
  styleUrl: 'notification-host.scss',
  shadow: true,
})
export class NotificationHostComponent implements ComponentInterface {
  /** positioning of notifications on the page */
  @Prop({ reflect: true })
  public position: NotificationPosition = 'bottom-end';

  public render(): JSX.Element {
    return (
      <Host class="wb-notification-host">
        <slot />
      </Host>
    );
  }
}
